import { useTranslation } from "react-i18next";
import { Button } from "@carbon/react";
import AwardedTable from "../../AwardedTable/AwardedTable";
import { OfferAwardedForDeliveryResponse } from "../../../types";

interface DeliverySupplierPickerProps {
  offersAwardedForDeliveries: OfferAwardedForDeliveryResponse[];
  onSupplierSelect: (item: OfferAwardedForDeliveryResponse) => void;
  onCreateNew: () => void;
}

/**
 * The awarded-supplier selection step shown before the create-delivery form when there are offers
 * awarded for delivery: pick a supplier (auto-fills the form) or start a blank "simple delivery".
 * `AwardedTable` is reused unchanged (still Tailwind) — the task's "reuse existing pickers" rule and
 * the expected mid-migration "Carbon chrome around Tailwind content" state.
 */
const DeliverySupplierPicker = ({
  offersAwardedForDeliveries,
  onSupplierSelect,
  onCreateNew,
}: DeliverySupplierPickerProps) => {
  const { t } = useTranslation();

  return (
    <div>
      <div className="new-delivery-form__actions new-delivery-form__notice">
        <h3>{t("deliveries.selectSupplier")}</h3>
        <Button onClick={onCreateNew}>{t("deliveries.createNew")}</Button>
      </div>
      <AwardedTable
        awardedOrdersSuppliers={offersAwardedForDeliveries}
        handleSupplierSelect={onSupplierSelect}
      />
    </div>
  );
};

export default DeliverySupplierPicker;
